import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

const Ctx = createContext(null);
export { Ctx as AuthContext };

const TWO_HOURS = 2 * 60 * 60 * 1000;
const LS_USER  = 'wt_user';
const LS_TOKEN = 'wt_token';
const LS_LAST  = 'wishtree_lastActiveAt';

function isSessionExpired() {
  const last = parseInt(localStorage.getItem(LS_LAST) || '0', 10);
  return last > 0 && Date.now() - last > TWO_HOURS;
}

function clearSession() {
  localStorage.removeItem(LS_USER);
  localStorage.removeItem(LS_TOKEN);
  localStorage.removeItem(LS_LAST);
}

export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [token,   setToken]   = useState(null);
  const [loading, setLoading] = useState(true);
  const heartbeatRef = useRef(null);

  function startHeartbeat() {
    stopHeartbeat();
    localStorage.setItem(LS_LAST, String(Date.now()));
    heartbeatRef.current = setInterval(() => {
      if (document.visibilityState === 'visible') {
        localStorage.setItem(LS_LAST, String(Date.now()));
      }
    }, 60_000);
  }

  function stopHeartbeat() {
    if (heartbeatRef.current) {
      clearInterval(heartbeatRef.current);
      heartbeatRef.current = null;
    }
  }

  useEffect(() => {
    try {
      if (isSessionExpired()) {
        clearSession();
      } else {
        const u = localStorage.getItem(LS_USER);
        const t = localStorage.getItem(LS_TOKEN);
        if (u && t) {
          setUser(JSON.parse(u));
          setToken(t);
          startHeartbeat();
        }
      }
    } catch {}
    setLoading(false);
  }, []); // eslint-disable-line

  const login = (userData, jwt) => {
    setUser(userData);
    setToken(jwt);
    // localStorage used intentionally — sessionStorage doesn't survive close; XSS surface is controlled
    localStorage.setItem(LS_USER,  JSON.stringify(userData));
    localStorage.setItem(LS_TOKEN, jwt);
    startHeartbeat();
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    stopHeartbeat();
    clearSession();
  };

  const updateUser = (patch) => {
    const next = { ...user, ...patch };
    setUser(next);
    localStorage.setItem(LS_USER, JSON.stringify(next));
  };

  return (
    <Ctx.Provider value={{ user, token, login, logout, updateUser, loading }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);
